import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, Sparkles, Heart } from 'lucide-react';

const steps = [
  {
    n: '01',
    icon: Calendar,
    title: 'Book',
    desc: 'Pick your service, date, and time through the booking page. Same-day available before 6PM. Emergency in-the-hour bookings available with an upcharge.',
  },
  {
    n: '02',
    icon: MapPin,
    title: 'We Arrive',
    desc: 'Christina (or one of our trained artists) arrives at your door — anywhere in Northeast Florida or Southern Georgia — with everything needed for your service.',
  },
  {
    n: '03',
    icon: Sparkles,
    title: 'You Glow',
    desc: 'Relax in your own space. Enjoy luxury service tailored to your style, including AI 3D nail art on every nail appointment.',
  },
  {
    n: '04',
    icon: Heart,
    title: 'Repeat',
    desc: 'Subscribe to a monthly plan or book one-time visits. Refer friends and earn $10 Nail Cash each time they book.',
  },
];

const HowItWorks = () => {
  return (
    <div className="py-20" data-testid="how-it-works-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[10px] tracking-[0.35em] uppercase text-amber-300/70 mb-4">✦ How It Works ✦</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-amber-50" data-testid="how-title">
            From booking to <span className="italic text-pink-300">glow-up</span> in 4 easy steps
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className="rounded-2xl bg-[#0a0405] border border-amber-900/30 p-8"
              data-testid={`step-${i + 1}`}
            >
              <div className="flex items-start gap-4">
                <div className="font-serif text-5xl text-amber-300/60">{s.n}</div>
                <div className="flex-1">
                  <s.icon className="w-6 h-6 text-pink-300 mb-3" />
                  <h3 className="font-serif text-2xl text-amber-100">{s.title}</h3>
                  <p className="mt-3 text-sm text-amber-100/70 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 max-w-3xl mx-auto rounded-2xl border border-amber-900/30 bg-gradient-to-br from-pink-950/20 to-amber-950/20 p-10 text-center" data-testid="emergency-callout">
          <div className="text-[10px] tracking-[0.3em] uppercase text-amber-300/70 mb-3">⚡ Need it NOW?</div>
          <h3 className="font-serif text-3xl text-amber-50">Emergency Within The Hour</h3>
          <p className="mt-4 text-amber-100/70">
            Have a wedding, event, or last-minute need? We can arrive within the hour for an upcharge. Book the emergency option directly from your booking page or call us.
          </p>
          <Link to="/book" className="inline-block mt-6 px-8 py-3 rounded-full bg-pink-300 text-black font-medium hover:bg-pink-200 transition-all" data-testid="emergency-cta">
            Book Emergency Service
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
